import { Menu } from 'antd';
import styles from './leftMenu.module.scss';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';

const MenuComp = (data: any[], onTitleClick: any) => {
    return data.map((item: Record<string, any>) => {
        if (item.subs && item.subs.length) {
            return (
                <Menu.SubMenu title={item.name} key={item.downloadCatagoryId} onTitleClick={onTitleClick}>
                    {MenuComp(item.subs, onTitleClick)}
                </Menu.SubMenu>
            );
        }
        return <Menu.Item key={item.downloadCatagoryId}>{item.name}</Menu.Item>;
    });
};

export default function LeftMenu({ data, onSelect, onTitleClick }: any) {
    return (
        <div className={styles.leftMenu}>
            <Menu
                mode="inline"
                className="ef-download-menu-custom z1"
                onClick={onSelect}
                expandIcon={(props) => {
                    return (
                        <div className={`icon ${props.isOpen ? 'open' : ''}`}>
                            <EFArrowDown style={{ color: '#03060b', fontSize: '14px' }} />
                        </div>
                    );
                }}
            >
                {MenuComp(data, onTitleClick)}
            </Menu>
        </div>
    );
}
